import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/website/src/components/common/card-media/card-media.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/website/src/components/common/resource-item/resource-item.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/website/src/components/common/switch-image/switch-image.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AwardsCarouselItems"] */ "/vercel/path0/apps/website/src/components/sections/awards-carousel/awards-carousel.items.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/website/src/components/sections/color-list/color-list.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/website/src/components/sections/color-variation-carousel/color-variation-carousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/website/src/components/sections/documentation-header/documentation-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/website/src/components/sections/gallery/gallery.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/website/src/components/sections/hero-parallax/hero-parallax.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/website/src/components/sections/hero/hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/website/src/components/sections/image-parallax/image-parallax.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SliderSwiper"] */ "/vercel/path0/apps/website/src/components/sections/slider/slider.swiper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/website/src/components/ui/button/button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/website/src/components/util/section-header/section-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/website/src/components/util/video/video.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/website/src/svg/alert_circle.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/website/src/svg/arrow_down.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/website/src/svg/arrow_left.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/website/src/svg/arrow_right.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/website/src/svg/arrow_top_right.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/website/src/svg/blending_mode.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/website/src/svg/brand_full.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/website/src/svg/brand.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/website/src/svg/checked_circle.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/website/src/svg/checked.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/website/src/svg/chevron_down.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/website/src/svg/chevron_left.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/website/src/svg/chevron_right.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/website/src/svg/close_circle.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/website/src/svg/copy.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/website/src/svg/link.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/website/src/svg/loader.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/website/src/svg/lock.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/website/src/svg/search.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
